import React from "react";
import { NavLink } from "react-router-dom";
import { Flame, Heart, MessageCircle, User, Crown } from "lucide-react";
import { useNotifications } from "../context/NotificationContext";

const items = [
  { to: "/decouvrir", icon: Flame, label: "Découvrir", testid: "nav-discover" },
  { to: "/likes", icon: Heart, label: "Likes", testid: "nav-likes", badgeKey: "likes" },
  { to: "/matchs", icon: MessageCircle, label: "Matchs", testid: "nav-matches", badgeKey: "messages" },
  { to: "/selection", icon: Crown, label: "Sélection", testid: "nav-selection" },
  { to: "/profil", icon: User, label: "Profil", testid: "nav-profile", badgeKey: "visits" },
];

const BottomNav = () => {
  const { counts } = useNotifications() || { counts: {} };

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 w-full md:max-w-md md:left-1/2 md:-translate-x-1/2 bg-white/85 backdrop-blur-xl border-t border-kora-line pt-3 pb-5 px-4 flex justify-around items-center rounded-t-3xl z-50 shadow-[0_-4px_20px_rgba(44,30,22,0.06)]"
    >
      {items.map(({ to, icon: Icon, label, testid, badgeKey }) => {
        const count = badgeKey ? counts?.[badgeKey] || 0 : 0;
        return (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className={({ isActive }) =>
              `relative flex flex-col items-center gap-1 transition-all ${
                isActive ? "text-kora-terracotta scale-110" : "text-kora-muted hover:text-kora-ink"
              }`
            }
          >
            <div className="relative">
              <Icon size={24} strokeWidth={2.2} />
              {count > 0 && (
                <span
                  data-testid={`nav-badge-${badgeKey}`}
                  className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 flex items-center justify-center rounded-full bg-kora-terracotta text-white text-[9px] font-bold leading-none border border-white"
                >
                  {count > 9 ? "9+" : count}
                </span>
              )}
            </div>
            <span className="text-[10px] font-medium">{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default BottomNav;
